exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0c5b119e].el-input--small{font-size:12px !important}.label[data-v-0c5b119e]{font-size:12px;color:#999}.slider-box[data-v-0c5b119e]{width:81%}.c_row-item[data-v-0c5b119e]{margin-bottom:20px}", ""]);

// exports
